<template>
  <div v-if="isOpen" class="popup-content"
       :style="{ top: `${position.top}px`, left: `${position.left}px` }"
       v-click-outside="() => closePopup()">
    <div class="popup-content-head">
      <button class="close-button" @click="closePopup" data-qa="popup-button-close">
        <vita-icon name="cross-dark"/>
      </button>
    </div>
    <div class="popup-content-body">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch, onUnmounted } from 'vue';

const props = defineProps<{
  isOpen: boolean;
  targetRef: HTMLElement | null;
}>();
const emit = defineEmits<{
  (e: 'close'): void;
}>();

const position = ref({ top: 0, left: 0 });

const updatePosition = () => {
  if (props.isOpen && props.targetRef) {
    const rect = props.targetRef.getBoundingClientRect();
    const popupWidth = 322; // ширина окна
    const screenWidth = window.innerWidth;

    let left = rect.left + window.scrollX;
    // не выходим ли за правый край экрана
    if (left + popupWidth > screenWidth) {
      left = screenWidth - popupWidth - 17; // отступаем на 17px от края
    }

    position.value = {
      top: rect.top,
      left: left,
    };
  }
}

const closePopup = () => emit('close')

// Обновляем позицию при открытии и добавляем обработчики событий
watch(
  () => props.isOpen,
  (newVal) => {
    if (newVal) {
      updatePosition();
      window.addEventListener('resize', closePopup);
    } else {
      window.removeEventListener('resize', closePopup);
    }
  }
);

onUnmounted(() => {
  window.removeEventListener('resize', closePopup);
});
</script>

<style lang="scss" scoped>
.popup-content {
  position: absolute;
  background-color: white;
  border-radius: 8px;
  width: 322px;
  z-index: 1100;
  box-shadow: -1px 0px 12px rgba(0, 0, 0, 0.15);
}

.popup-content-head {
  display: flex;
  justify-content: flex-end;
  background: #DDDDDD;
  border-radius: 3px 3px 0 0;
  padding: 12px 24px;
}

.popup-content-body {
  background: white;
  padding: 16px 24px 24px;
}

.close-button {
  appearance: none;
  border: 0;
  font-family: inherit;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
}
</style>